import { gql } from '@apollo/client';

import { LeadFragment } from '../fragments/LeadFragment';

export type {
  SearchReferrals as ISearchReferrals,
  SearchReferralsVariables as ISearchReferralsVariables,
  SearchReferrals_searchReferrals_referrals as IReferral,
  SearchReferrals_searchReferrals_referrals_lead_offer as IOffer,
} from './__generated__/SearchReferrals';

export const SEARCH_REFERRALS = gql`
  query SearchReferrals($input: SearchReferralsInput!) {
    searchReferrals(input: $input) {
      referrals {
        lead {
          ...LeadFragment
        }
        sellerInputId
        state
        uuid
      }
    }
  }
  ${LeadFragment}
`;
